import { createContext } from "react";

const servicesContext = createContext();

export default servicesContext;